/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Work_Plan_CollapseInputs */



/**
* | output |
* | --- |
* | "Hide plan" |
*
* @param {Chat_Work_Plan_CollapseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_work_plan_collapse = /** @type {((inputs?: Chat_Work_Plan_CollapseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Work_Plan_CollapseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Plan ausblenden")
	return /** @type {LocalizedString} */ ("Hide plan")
});